// SyncConfigBaseView.js
import React from 'react';
import InfoDialog from '@au/core/lib/components/objects/InfoDialog';
import AutoIntl from '@au/core/lib/components/elements/AutoIntl';
import LoadingIndicator from '@au/core/lib/components/elements/LoadingIndicator';
import { BUTTON_TYPE_PRIMARY } from '@au/core/lib/components/elements/AuButton';
import DefaultView from '../View';
import SyncConversionRuleDialog from '../../SyncConversionRuleDialog';
import { pruneCurrentStatusKeys } from '../../../utils/telemetryUtils';

import styles from '../../../css/components/conversion_sync_config.module.scss';

export default class SyncConfigBaseView extends DefaultView {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      loading: true,
      showSyncNowDialog: false,
      showSuccessDialog: false,
    };
  }

  // Subclasses must implement: this.syncConfigsEndpoint (or equivalent)
  // used by triggerSync below.
  getSyncEndpoint() {
    return this.props.endpoint;
  }

  // Subclasses may override to pull the sync config from a different place.
  getSyncConfig(defaultValue) {
    return defaultValue;
  }

  pruneAttributes() {
    return pruneCurrentStatusKeys(this.props.entity, this.props.entityDef.attributes);
  }

  renderSection() {
    if (this.state.loading) {
      return (
        <div className={styles.loading}>
          <LoadingIndicator />
        </div>
      );
    }

    return super.renderSection();
  }

  renderTableRows() {
    return super.renderTableRows(this.pruneAttributes());
  }

  // Default: always show the action
  hasSyncConfig() {
    return true;
  }

  getActions() {
    if (!this.hasSyncConfig()) return [];

    return [
      {
        key: 'sync_now_btn',
        type: BUTTON_TYPE_PRIMARY,
        displayId: 'au.entity.action.syncNow',
        onClick: () => this.setState({ showSyncNowDialog: true }),
      },
    ];
  }

  async handleSyncConfirmation(syncId, targetEnv) {
    try {
      await this.getSyncEndpoint().triggerSync(syncId, targetEnv);
      this.setState({ showSyncNowDialog: false, showSuccessDialog: true });
    } catch (e) {
      this.setState({ showSyncNowDialog: false });
      this.genericErrorHandler(e);
    }
  }

  getSyncConfigForDialog() {
    return this.props.entity.toJS();
  }

  renderDialogs() {
    const { showSyncNowDialog, showSuccessDialog } = this.state;
    const dialogs = [];

    if (showSyncNowDialog) {
      dialogs.push(
        <SyncConversionRuleDialog
          key='SyncNow'
          onConfirm={this.handleSyncConfirmation.bind(this)}
          onCancel={() => this.setState({ showSyncNowDialog: false })}
          syncConfig={this.getSyncConfigForDialog()}
        />,
      );
    }

    if (showSuccessDialog) {
      dialogs.push(
        <InfoDialog
          key='SuccessCreate'
          titleId='au.entity.success'
          className={styles.success_dialog}
          bodyClassName={styles.success_dialog_body}
          closeClassName={styles.success_dialog_close_button}
          buttonType={BUTTON_TYPE_PRIMARY}
          showClose={false}
          onClose={() => this.setState({ showSuccessDialog: false })}
        >
          <AutoIntl displayId='au.telemetry.sync.success' tag='div' />
        </InfoDialog>,
      );
    }

    return dialogs;
  }
}
